import { forwardRef, InputHTMLAttributes } from "react";
import PhoneNumberInput from 'react-phone-number-input/input'
import { Input as InputBarte } from "barte-design-system";

interface PhoneInput2Props {
  type?: string;
  name?: string;
  label?: string;
  valueData?: string;
  setValue?: (value?: string) => void;
  errors?: { message?: string };
  isDisabled?: boolean;
}

const PhoneInputField = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { error?: string }
>((props, ref) => <InputBarte ref={ref} {...(props as any)} />);

export function PhoneInput2({
  valueData,
  setValue,
  errors,
  isDisabled,
  ...rest
}: PhoneInput2Props) {
  return (
    <PhoneNumberInput
      defaultCountry="BR"
      value={valueData}
      onChange={setValue}
      inputComponent={PhoneInputField}
      error={errors?.message}
      disabled={isDisabled}
      {...rest}
    />
  );
}
